
import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Router } from '@angular/router';
import { ApiEvsService } from './ApiEvs.service';
import { TypeaheadOptions } from 'ngx-bootstrap';

@Injectable()
export class FieldService extends ApiEvsService {
    constructor(http: Http, router: Router) {
        super(http, router);
    }

    list(query?: any) {
        return this.get('/fields',query);
    }

    create(body: any) {
        return this.post('/field',body);
    }

    find(id) {
        return this.get('/field/'+id);
    }

    update(id, body) {
        return this.put('/field/'+id, body);
    }

    allField(query?: any) {
        return this.get('/all-field', query);
    }

    _delete(id) {
        return this.delete('/field/'+id);
    }
}



// WEBPACK FOOTER //
// G:/3csoft/client-final/src/app/common/services/Field.service.ts